export default "__VITE_ASSET__C5P7blmG__"